import React, { useEffect, useRef } from 'react'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

// Store
import { actions } from 'core/store'

// Hooks
import { useGenerateIntegrationToken } from 'core/hooks/api'

// Styled Elements

// Views
import {
  Button,
  Form,
  FormTextField,
  FormDatePicker,
  // FormSelect
} from 'views/components'
import { FormContainer, FormFooter, FormInfo, FormInputGroupItem, FormWrapper } from './CreateApiKeyForm.elements'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function CreateApiKeyForm(props) {
  // Destructure
  const { setResponse } = props

  // Hooks
  const {
    generateIntegrationToken,
    generateIntegrationTokenData,
    generateIntegrationTokenError,
    isGenerateIntegrationTokenLoading,
  } = useGenerateIntegrationToken()

  // Store Actions
  // const {} = actions

  // Internal State

  // Variables
  const formRef = useRef()

  const validationSchema = Yup.object().shape({
    label: Yup.string().required('Label is required'),
    expires: Yup.string().required('Expiry Date is required'),
    allowed_ips: Yup.string()
      .matches(
        /^(?:\d{1,3}\.){3}\d{1,3}(?:,(?:\d{1,3}\.){3}\d{1,3})*$/,
        'Must be comma-separated IP addresses with no spaces',
      )
      .test('valid-ip-range', 'Must be valid IP addresses', (value) => {
        if (!value) return true // optional field

        const ips = value.split(',')

        return ips.every((ip) => {
          const parts = ip.split('.')
          return parts.every((part) => {
            const num = Number(part)
            return num >= 0 && num <= 255
          })
        })
      }),
  })

  // Functions
  const triggerSubmit = () => {
    formRef.current.submitForm()
  }
  const handleOnSubmit = (values) => {
    const payload = {
      ...values,
    }
    generateIntegrationToken(payload)
  }

  // UseEffects
  useEffect(() => {
    if (setResponse) setResponse(generateIntegrationTokenData)
  }, [generateIntegrationTokenData])
  return (
    <FormWrapper>
      <Form formRef={formRef} validationSchema={validationSchema} onSubmit={handleOnSubmit}>
        {generateIntegrationTokenError && <FormInfo>Could not generate an API Key</FormInfo>}
        {!generateIntegrationTokenError && (
          <>
            <FormContainer>
              <FormInputGroupItem>
                <FormTextField label="Label" name="label" />
              </FormInputGroupItem>

              <FormInputGroupItem>
                <FormDatePicker
                  label="Expiry Date"
                  name="expires"
                  future
                  maxDate={moment().add(1, 'years').format('MMM DD YYYY')}
                />
              </FormInputGroupItem>

              <FormInputGroupItem>
                <FormTextField label="Allowed IPs (comma-separated)" name="allowed_ips" />
              </FormInputGroupItem>
            </FormContainer>

            <FormFooter>
              <Button
                size="medium"
                type="button"
                onClick={triggerSubmit}
                disabled={isGenerateIntegrationTokenLoading}
                fullWidth
              >
                {isGenerateIntegrationTokenLoading ? 'Generating an API Key...' : 'Create Key'}
              </Button>
            </FormFooter>
          </>
        )}
      </Form>
    </FormWrapper>
  )
}

// Default Props
CreateApiKeyForm.defaultProps = {
  formRef: {},
  form: {
    toBeUpdatedVasp: null,
  },
  actions: {},
}

// Proptypes Validation
CreateApiKeyForm.propTypes = {
  formRef: PropTypes.shape({ root: PropTypes.string }),
  form: PropTypes.shape({
    countryListOptions: PropTypes.instanceOf(Array),
    toBeUpdatedVasp: PropTypes.shape({
      vasp_id: PropTypes.string,
    }),
  }),
  setResponse: PropTypes.func,
  actions: PropTypes.shape({
    setShowHeaderLoader: PropTypes.func,
    setToBeUpdatedVasp: PropTypes.func,
    setCreatedVasp: PropTypes.func,
    showAlert: PropTypes.func,
    toggleCreateApiKeyModal: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setIsRecordUpdated: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateApiKeyForm)
